<template>
    <div class="container py-4">
        <h2 class="mb-4">Users</h2>
        <router-link :to="{name: 'userCreate'}" class="btn btn-outline-success btn-sm mb-3">New user</router-link>
        <div class="card">
            <div class="card-body">
                <vue-good-table
                        :columns="columns"
                        :isLoading.sync="isLoading"
                        :pagination-options="{enabled: true}"
                        :rows="table.rows"
                        :totalRows="table.totalRecords"
                        :sort-options="{
                            enabled: false
                          }"
                        @on-column-filter="onColumnFilter"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        mode="remote"
                        styleClass="table table-hover">
                    <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'name'">
                    <router-link :to="{name: 'userUpdate', params: {id: props.row.id}}">{{props.row.name}}</router-link>
                </span>
                        <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>
<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import {VueGoodTable} from 'vue-good-table';
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: 'userIndex',
        data() {
            return {
                isLoading: false,
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                    },
                    {
                        label: 'Email',
                        field: 'email',
                    },
                    {
                        label: 'Roles',
                        field: function (roles) {
                            return (roles.roles[0]) ? roles.roles[0].name : ''
                        },
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: '',
                        type: '',
                    },
                    page: 1,
                    perPage: 10
                }
            };
        },
        computed: mapGetters({
                table: 'TABLE'
            }
        ),
        components: {
            VueGoodTable,
        },
        mounted() {
            this.loadItems()
        },
        methods: {
            ...mapActions({
                    loadItems: 'GET_USERS',
                }
            ),
            updateParams(newProps) {
                this.$store.dispatch('CHANGE_SERVERPARAMS', newProps)
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.columns[params.columnIndex].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            }
        }
    }
</script>
<style>
    .vgt-wrap__footer {
        color: #ffffff;
        padding: 0.5em !important;
        border: none !important;
        border-top: 1px solid #dcdfe6 !important;
        background: #ffffff !important;
    }
</style>
